export default function getQueryString() {
  return window.location.search;
}